export const GET_HEALTH_LIST = 'GET_Health_LIST';
export const GET_DETAIL_DATA = 'GET_DETAIL_DATA';
export const CLEAN_LIST_DATA = 'Clean_LIST_DATA';
export const CHANGE_LOADSTATUS_DATA = 'CHANGE_LOADSTATUS_DATA';
export const UPDATE_VOTENUMBER = 'UPDATE_VOTENUMBER';
